
var allTagTypes =  {
    location: ["city", "state", "region", "district"],
    participant: ["status", "admin", "amc", "activity", "ybusa",
                  "pse-cohort", "tag", "year", "issues", 'dst',
                  'slot'],
    program: ["dol", "grant", "tribal", "affiliation", "operating", "rural",
              "initiative", "program-id", 'amc-pm', 'amc-fm']
}, tagTypeMap = {};


for (var tagType in allTagTypes) {
    for (var i = 0; i < allTagTypes[tagType]; i++) {
        tagTypeMap[allTagTypes[tagType][i]] = tagType;
    }
}


function TagUrl(tagTypes, defaults) {
    this.tags = [];
    this.params = {};
    this.extraParamNames = [];
    this.addTagTypes(tagTypes || [], defaults || {});
}

TagUrl.prototype.clone = function() {
    return angular.copy(this);
};

TagUrl.prototype.addExtraParam = function(name, config) {
    var urlName = name;

    if (angular.isString(config)) {
        config = {
            value: config,
            squash: true,
        };
    }

    if (config.type) {
        urlName += ":" + config.type;
        delete config.type;
    }

    this.params[name] = config;
    this.extraParamNames.push(urlName);
    return this;
};

TagUrl.prototype.addPagerParams = function() {
    this.addExtraParam('page', {value: 1, type: 'int', squash: true})
    return this;
};

TagUrl.prototype.addSorterParams = function(column, direction) {
    direction = direction || 'asc';
    this.addExtraParam('sort', {value: column, squash: true});
    this.addExtraParam('direction', {value: direction, squash: true});
    return this;
};

TagUrl.prototype.addTag = function(name, defaultValue) {
    var index = this.tags.indexOf(name);
    if (index === -1) {
        this.tags.push(name);
        this.params[name] = {array: true, squash: true};
        this.setTagDefault(name, defaultValue);
    }
    return this;
};

TagUrl.prototype.removeTag = function(name) {
    var index = this.tags.indexOf(name);
    if (index >= 0) {
        this.tags.splice(index, 1);
        delete this.params[name];
    }
    return this;
};

TagUrl.prototype.setTagDefault = function(name, value) {
    if (angular.isDefined(value)) {
        value = angular.isArray(value) ? value : [value];
        this.params[name].value = value;
    } else {
        delete this.params[name].value;
    }
    return this;
};

TagUrl.prototype.addTagType = function(type, defaults) {
    var name, i;
    defaults = defaults || {};
    for (i = 0; i < allTagTypes[type].length; i++) {
        name = allTagTypes[type][i];
        this.addTag(name, defaults[name]);
    }
    return this;
};

TagUrl.prototype.addTagTypes = function(types, defaults) {
    defaults = defaults || {};
    for (var i = 0; i < types.length; i++) {
        this.addTagType(types[i], defaults);
    }
    return this;
};

TagUrl.prototype.addDefaults = function(params) {
    var i, name;
    for (i = 0; i < this.tags.length; i++) {
        name = this.tags[i];
        if (this.params[name].value && !params[name]) {
            params[name] = this.params[name].value;
        }
    }
};

TagUrl.prototype.addEmptyTags = function(params) {
    var i, name;
    for (i = 0; i < this.tags.length; i++) {
        name = this.tags[i];
        params[name] = params[name] || [];
        if (this.params[name].value && params[name].length === 0) {
            params[name] = true;
        }
    }
};

TagUrl.prototype.buildUrl = function(baseUrl) {
    baseUrl = baseUrl || "";
    return baseUrl += (baseUrl.indexOf('?') === -1 ? "?" : '&') + this.queryString;
};

Object.defineProperty(TagUrl.prototype, 'queryString', {
    get: function() {
        return "{" + this.tags.join("}&{") + this.extraParamNames.join("}&{") + "}";
    },
});

module.constant('TagUrlOld', TagUrl);
